import axios from 'frontend/_config/axios'
import setupRouter from 'frontend/_setup/setupRouter/setupRouter'
import { POST, ResourceService } from 'frontend/common/services/resource-service'
import { SimpleSelectService } from 'frontend/common/services/simple-select-service'

export const FIELDS_FOR_SELECT = [
  'id',
  'fleet_number',
  'registration_plate',
  'cluster_id',
  'bus_module_subsystem_ids',
  { cluster: ['id', 'name', 'time_zone'] },
  { vehicle_model: ['id', 'name', { vehicle_brand: ['id', 'name'] }] },
  { vehicle_category: ['id', 'name', 'background_color', 'border_color', 'font_color'] },
  { vehicle_type: ['id', 'name'] },
]
export class VehiclesService extends ResourceService {
  constructor({
    eventSlug = setupRouter.currentRoute.value.params.eventSlug,
    baseUrl = `/events/${eventSlug}/vehicles`,
    blocker,
    fetchError = 'Failed to fetch vehicle.',
    saveError = 'Failed to save vehicle.',
    apiProvider = axios,
    selectService = new SimpleSelectService(baseUrl, {
      apiProvider,
      blocker,
      blockerKey: 'vehicles',
    }),
  } = {}) {
    super({
      apiProvider,
      baseUrl,
      blocker,
      fetchError,
      saveError,
    })
    this.selectService = selectService
  }

  getForSelect() {
    return (additionalPayload = {}) =>
      this.selectService.fetchOptions({
        additionalPayload,
        sorts: ['fleet_number_prefix asc', 'fleet_number_int asc'],
        fields: FIELDS_FOR_SELECT,
        path: `${this.selectService.baseUrl}/selection_index`,
      })
  }

  suggestedFor(
    driverId,
    maxEnd,
    { errorHandler = this._onFetchError, url = `${this.baseUrl}/suggested_for`, data } = {},
    config = {},
  ) {
    return this._makeCall(POST, errorHandler, {
      url,
      data: { driverId, maxEnd, ...data },
      ...config,
    })
  }

  suggestedForMultiple(
    driverIds,
    maxEnd,
    { errorHandler = this._onFetchError, url = `${this.baseUrl}/suggested_for`, data } = {},
    config = {},
  ) {
    return this._makeCall(POST, errorHandler, {
      url,
      data: { driverIds, maxEnd, ...data },
      ...config,
    })
  }
}
